export default __webpack_public_path__ + "static/media/316.a2560405.jpg";